<script>
import Button from '../buttons/Button';
import FormModal from '../modals/FormModal';

export default {
    components: {
        Button,
        FormModal
    },
    props: {
        isShow: Boolean,
        title: String,
        isButtonLoading: Boolean,
        isShowSubmitButton: Boolean,
        isShowCancelButton: Boolean,
        clickSubmitButton: Function,
        submitButtonText: String,
        isModalScrollable: Boolean,
        modalSize: String,
        noClose: {
            type: Boolean,
            default: false
        },
        closeButtonText: {
            type: String,
            default: 'Close'
        },
        isSubmitDisabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            modalShow: false
        }
    },

    methods: {
        hideModal() {
            this.modalShow = false;
            this.$emit('hideModal', this.modalShow)
        }
    },

    watch: {
        isShow: function(){
            this.modalShow = this.isShow;
        }
    }
};
</script>

<template>
    <b-modal
        v-model="modalShow"
        hide-footer
        centered
        header-class="border-0"
        :size="modalSize"
        :scrollable="isModalScrollable"
        :title="title"
        @hidden="hideModal"
        :hide-header-close="noClose"
        :no-close-on-backdrop="noClose"
        :no-close-on-esc="noClose"
    >
        <slot></slot>
        <div class="text-end mt-3">
            <Button 
                variant="light" 
                :onClick="hideModal"
                :disabled="isButtonLoading"
                v-if="isShowCancelButton"
                v-html="closeButtonText"
                >
            </Button>
            <Button 
                variant="success"
                :onClick="clickSubmitButton"
                type="submit" 
                classes="ms-1" 
                :disabled="isButtonLoading || isSubmitDisabled"
                v-html="submitButtonText"
                v-if="isShowSubmitButton"
                >
            </Button>
        </div>
    </b-modal>
</template>